export type DetectEventPayload = {
  text: string[];
};
